export default "__VITE_ASSET__B_m0VZxQ__"